






























































































































































































































































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import PopupService from '@/services/popup.service';
import { PopupDto } from '@/dto';
import { CONST_YN, Pagination, YN } from '@/common';
import toast from '../../../../resources/assets/js/services/toast.js';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';
import { CodeManagementDto } from '@/services/init/dto/index.js';
import CodeManagementService from '../../../services/code-management.service';
import { POPUP } from '@/services/shared';

@Component
export default class PopupList extends BaseComponent {
  private popupList: PopupDto[] = [];
  private popupSearchDto = new PopupDto();
  private popupCreateDto = new PopupDto();
  private pagination = new Pagination();
  private dataLoading = false;
  private popupTotalCount = null;
  private ynSelect: YN[] = [...CONST_YN];
  private popupTypeSelect: CodeManagementDto[] = [];
  private linkTypeSelect: CodeManagementDto[] = [];
  private popupImage: FileAttachmentDto[] = [];
  private startedDate: Date = null;
  private endedDate: Date = null;

  getLinkUrl(linkUrl: string) {
    if (linkUrl) {
      return linkUrl.includes('//') ? linkUrl : `//${linkUrl}`;
    }
  }

  getTypeCodes() {
    CodeManagementService.findAnyCode('POPUP').subscribe(res => {
      this.popupTypeSelect = res.data;
    });
    CodeManagementService.findAnyCode('LINK_TYPE').subscribe(res => {
      this.linkTypeSelect = res.data;
    });
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.popupSearchDto, this.pagination);
    }
    PopupService.findAll(this.popupSearchDto, this.pagination).subscribe(
      res => {
        if (res) {
          this.dataLoading = false;
          this.popupList = res.data.items;
          this.popupTotalCount = res.data.totalCount;
        }
      },
    );
  }

  search() {
    this.findAll(true, true);
  }
  paginateSearch() {
    this.findAll(true);
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.popupSearchDto = new PopupDto();
      this.findAll();
    }
  }

  // create popup
  createPopup() {
    if (this.popupCreateDto.popupType === POPUP.IMAGE) {
      if (this.popupImage.length > 0) {
        this.popupCreateDto.images = this.popupImage;
      } else {
        toast.error('이미지를 등록해주세요!');
        return;
      }
    }

    this.popupCreateDto.started = new Date(`${this.startedDate} 00:00:00`);
    this.popupCreateDto.ended = new Date(`${this.endedDate} 23:59:59`);

    PopupService.create(this.popupCreateDto).subscribe(res => {
      if (res) {
        toast.success('추가완료');
        this.clearOut();
        this.$bvModal.hide('add_popup');
      }
    });
  }

  // upload popup image
  async upload(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(UPLOAD_TYPE.POPUP, [
        file,
      ]);
      this.popupImage = [];
      this.popupImage.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
    }
  }

  clearOutPopupCreateDto() {
    this.popupImage = [];
    this.popupCreateDto = new PopupDto();
    this.$bvModal.hide('add_popup');
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.popupSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getTypeCodes();
  }
}
